// extracted by mini-css-extract-plugin
export default {"formHeading":"sJ-z","form":"tJ-z","submitBtn":"uJ-z","disabled":"vJ-z","input":"wJ-z","error":"xJ-z","submitMsg":"yJ-z","signIn":"zJ-z"};